// utils
import { VideoChannel } from '../../components/VideoGallery/reducer.types';

export const videoCenterChannelsSelector = (state: AppState): VideoChannel[] | null => {
  return state.videoCenter.channels;
};
